
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'formControl': {'width': `100%`,},'select': {'width': `100%`,'fontFamily': `'Lato-Regular', sans-serif`,'color': `#ffffff`,},'titleAndDropdownContainer': {'display': `flex`,'margin': `8px 0 0 0`,},'labelContainer': {'flex': `1`,'display': `flex`,'alignItems': `center`,},'dropdownContainer': {'width': `50%`,},'labelTitleText': {'fontSize': `14px`,'fontFamily': `'Lato-Regular', sans-serif`,'color': `#ffffff`,},'menuListRoot': {'paddingRight': `1vw`,},
        
      };
    };
  